export class DebugLogger {
    name: string;
    enabled: boolean;

    constructor(name: string, enabled: boolean) {
        this.name = name;
        this.enabled = enabled;
        console.log("DebugLogger", name, enabled);
    }

    enable() {
        this.enabled = true;
    }

    disable() {
        this.enabled = false;
    }

    group(...args: any[]) {
        if (this.enabled) {
            console.group.apply(console, args);
        }
    }

    groupCollapsed(...args: any[]) {
        if (this.enabled) {
            console.groupCollapsed.apply(console, args);
        }
    }

    groupEnd(...args: any[]) {
        if (this.enabled) {
            console.groupEnd.apply(console, args);
        }
    }

    debug(...args: any[]) {
        if (this.enabled) {
            console.debug.apply(console, args);
        }
    }

    warn(...args: any[]) {
        if (this.enabled) {
            console.warn.apply(console, args);
        }
    }

    error(...args: any[]) {
        if (this.enabled) {
            console.error.apply(console, args);
        }
    }
}

export const luaConsole = new DebugLogger(
    "lua",
    !(globalThis as any).config?.disableLuaLog
);

export const qsdConsole = new DebugLogger(
    "qsd",
    !(globalThis as any).config?.disableQsdLog
);
